"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _types = require("./types");
Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _types[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _types[key];
    }
  });
});
var _useGetProductInfoDialogProducts = require("./useGetProductInfoDialogProducts");
Object.keys(_useGetProductInfoDialogProducts).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useGetProductInfoDialogProducts[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useGetProductInfoDialogProducts[key];
    }
  });
});
var _useGetProductBoxConfiguration = require("./useGetProductBoxConfiguration");
Object.keys(_useGetProductBoxConfiguration).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useGetProductBoxConfiguration[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useGetProductBoxConfiguration[key];
    }
  });
});
var _useProductInfoDialog = require("./useProductInfoDialog");
Object.keys(_useProductInfoDialog).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useProductInfoDialog[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useProductInfoDialog[key];
    }
  });
});
